module.exports = __webpack_public_path__ + "static/media/company-seven.56ad1be7.jpg";